import { fmtCompact } from '../../utils/statsFormat';

/**
 * Low→high swatch strip for the sequential charts.
 *
 * The polar coverage plot and the day×hour heatmap encode magnitude in colour
 * ALONE, which makes a scale legend mandatory rather than decorative — without
 * it the reader has no way to turn a shade back into a number, and the chart
 * fails on a continuous colour-only scale.
 *
 * The steps mirror the charts' own log opacity ramp, so a swatch here matches
 * the same value in the plot. Log, not linear: position counts span orders of
 * magnitude, and a linear ramp would leave everything but the busiest sector
 * indistinguishable from the surface.
 */
export const STEPS = 6;

/** Opacity for a normalised 0..1 value — the single source for both charts. */
export function seqOpacity(norm) {
  if (!(norm > 0)) return 0;
  return 0.12 + Math.log10(1 + Math.min(1, norm) * 9) * 0.73;
}

function ScaleLegend({ max, label, format = fmtCompact }) {
  const cells = Array.from({ length: STEPS }, (_, i) => (i + 1) / STEPS);

  return (
    <div className="chart-scale">
      {label && <span className="chart-scale-label">{label}</span>}
      <span className="chart-scale-end">0</span>
      <span className="chart-scale-strip" aria-hidden="true">
        {cells.map((n, i) => (
          <span
            key={i}
            className="chart-scale-cell"
            style={{ background: 'var(--chart-seq)', opacity: seqOpacity(n) }}
          />
        ))}
      </span>
      <span className="chart-scale-end">{format(max)}</span>
    </div>
  );
}

export default ScaleLegend;
